/* Shared by the React app (runtime) and scripts/postbuild.js (static HTML).
   CommonJS on purpose so Node can require() it without a bundler. */
const DEFAULT_SITE = "https://inovaantage.com";
const clean = (s) => String(s || DEFAULT_SITE).replace(/\/+$/, "");
const abs = (site, path) => clean(site) + (path === "/" ? "/" : path);

function organization(site) {
  site = clean(site);
  return {
    "@type": "Organization",
    "@id": site + "/#organization",
    name: "Inovaantage",
    url: site + "/",
    logo: { "@type": "ImageObject", url: site + "/dark_logo.png" },
    image: site + "/og-image.png",
    description:
      "Inovaantage provides IT and geospatial solutions for utilities, telecom and infrastructure organisations worldwide, including GIS and utility network migration, field force management and managed services.",
    email: "info@inovaantage.com",
    telephone: "+1 720 263 9280",
    sameAs: [
      "https://www.linkedin.com/company/inovaantage/",
      "https://twitter.com/inovaantage",
      "https://www.youtube.com/channel/UCTcGWLYt5CXlVLa0Q251QZQ",
    ],
    contactPoint: [
      { "@type": "ContactPoint", contactType: "sales", email: "info@inovaantage.com", telephone: "+1 720 263 9280", availableLanguage: "English" },
    ],
    location: [
      { "@type": "Place", name: "Inovaantage United States", address: { "@type": "PostalAddress", streetAddress: "473 E Carnegie Dr #200", addressLocality: "San Bernardino", addressRegion: "CA", postalCode: "92408", addressCountry: "US" } },
      { "@type": "Place", name: "Inovaantage United Kingdom", address: { "@type": "PostalAddress", streetAddress: "First Floor, Swan Buildings, 20 Swan Street", addressLocality: "Manchester", postalCode: "M4 5JW", addressCountry: "GB" } },
      { "@type": "Place", name: "Inovaantage Singapore", address: { "@type": "PostalAddress", streetAddress: "60 Paya Lebar Road #07-54", postalCode: "409051", addressCountry: "SG" } },
      { "@type": "Place", name: "Inovaantage India", address: { "@type": "PostalAddress", streetAddress: "Kavuri Hills, Madhapur", addressLocality: "Hyderabad", addressRegion: "Telangana", postalCode: "500033", addressCountry: "IN" } },
      { "@type": "Place", name: "Inovaantage Malaysia", address: { "@type": "PostalAddress", streetAddress: "Level 28, The Gardens South Tower", addressLocality: "Kuala Lumpur", addressCountry: "MY" } },
      { "@type": "Place", name: "Inovaantage Australia", address: { "@type": "PostalAddress", streetAddress: "8 Beulah Road", addressLocality: "Norwood", addressRegion: "SA", postalCode: "5067", addressCountry: "AU" } },
    ],
    knowsAbout: ["GIS", "Esri Utility Network migration", "Geospatial data management", "Field force management", "Outage management", "Managed IT services"],
  };
}

function website(site) {
  site = clean(site);
  return { "@type": "WebSite", "@id": site + "/#website", url: site + "/", name: "Inovaantage", inLanguage: "en", publisher: { "@id": site + "/#organization" } };
}

function orgGraph(site) {
  return { "@context": "https://schema.org", "@graph": [organization(site), website(site)] };
}

function pageGraph(site, route, faqs) {
  site = clean(site);
  const url = abs(site, route.canonical || route.path);
  const graph = [];
  const crumbs = [{ "@type": "ListItem", position: 1, name: "Home", item: site + "/" }];
  if (route.path !== "/") crumbs.push({ "@type": "ListItem", position: 2, name: route.crumb, item: url });
  graph.push({ "@type": "BreadcrumbList", "@id": url + "#breadcrumb", itemListElement: crumbs });

  const pageType = route.type === "Service" ? "WebPage" : route.type;
  graph.push({
    "@type": pageType, "@id": url + "#webpage", url, name: route.title, description: route.description, inLanguage: "en",
    isPartOf: { "@id": site + "/#website" }, about: { "@id": site + "/#organization" }, breadcrumb: { "@id": url + "#breadcrumb" },
  });
  if (route.type === "Service") {
    graph.push({
      "@type": "Service", "@id": url + "#service", name: route.h1 || route.crumb, serviceType: route.service || route.crumb,
      description: route.description, url, provider: { "@id": site + "/#organization" }, areaServed: "Worldwide",
    });
  }
  if (faqs && faqs.length) {
    graph.push({
      "@type": "FAQPage", "@id": url + "#faq", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
  }
  return { "@context": "https://schema.org", "@graph": graph };
}

// JSON for embedding in <script>: escape "<" so "</script>" can never appear.
const toJson = (o) => JSON.stringify(o).replace(/</g, "\\u003c");

module.exports = { DEFAULT_SITE, clean, abs, organization, website, orgGraph, pageGraph, toJson };
